import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const RevalidateOnLanguageChange: React.FC = () => {
  const { i18n } = useTranslation();
  const { validateForm, errors } = useFormikContext();

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      validateForm();
    }
  }, [i18n.language]); // eslint-disable-line react-hooks/exhaustive-deps -- intentionally only re-run on language change

  return null;
};

export default RevalidateOnLanguageChange;
